// extracted by css-extract-rspack-plugin
export default {"CommentBox":"Shared-module__CommentBox__QRnhHmO","Condensed":"Shared-module__Condensed__l1jAwOM"};